module.exports = __webpack_public_path__ + "static/media/fantest_unis_1.75cd5ae4.png";